import { API } from 'utils/api';
import { useDispatch } from 'react-redux';
import { LOGIN } from 'store/actions';
import { useNavigate } from 'react-router';
import { setLocalUserInfo, showError, showSuccess } from 'utils/common';

import { getJoinTeamBycode } from '../views/TeamManage/api';
import useNavFirstPage from 'hooks/useNavFirstPage';

const useLogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { navFirstPage } = useNavFirstPage();
  const getUserTeamInfo = async () => {
    const res = await API.get('/api/teams/check_user_status');
    const { success, message, data } = res.data;
    if (success) {
      return res.data;
    } else {
      return {};
    }
  };

  const login = async (username, password, loginType) => {
    try {
      const res = await API.post(`/api/user/login`, {
        username,
        password,
        login_type: loginType
      });
      const { success, message, data } = res.data;
      if (success) {
        const teamInfo = await getUserTeamInfo();
        setLocalUserInfo({ ...data, ...teamInfo });
        joinTeam();
        dispatch({ type: LOGIN, payload: data });
        navFirstPage();
      }
      return { success, message };
    } catch (err) {
      // 请求失败，设置错误信息
      return { success: false, message: '' };
    }
  };
  const accessTokenLogin = async (access_token) => {
    try {
      const res = await API.post(`/api/user/access_token/login?access_token=${access_token}`);
      const { success, message, data } = res.data;
      if (success) {
        const teamInfo = await getUserTeamInfo();
        setLocalUserInfo({ ...data, ...teamInfo });
        joinTeam();
        dispatch({ type: LOGIN, payload: data });
        navFirstPage();
      }
      return { success, message };
    } catch (err) {
      // 请求失败，设置错误信息
      return { success: false, message: '' };
    }
  };

  const githubLogin = async (code, state) => {
    try {
      const res = await API.get(`/api/oauth/github?code=${code}&state=${state}`);
      const { success, message, data } = res.data;
      if (success) {
        if (message === 'bind') {
          showSuccess('绑定成功！');
          navFirstPage();
        } else {
          dispatch({ type: LOGIN, payload: data });
          const teamInfo = await getUserTeamInfo();
          setLocalUserInfo({ ...data, ...teamInfo });
          showSuccess('登录成功！');
          joinTeam();
          navFirstPage();
        }
      }
      return { success, message };
    } catch (err) {
      // 请求失败，设置错误信息
      return { success: false, message: '' };
    }
  };

  const larkLogin = async (code, state) => {
    try {
      const res = await API.get(`/api/oauth/lark?code=${code}&state=${state}`);
      const { success, message, data } = res.data;
      if (success) {
        if (message === 'bind') {
          showSuccess('绑定成功！');
          navFirstPage();
        } else {
          dispatch({ type: LOGIN, payload: data });
          const teamInfo = await getUserTeamInfo();
          setLocalUserInfo({ ...data, ...teamInfo });
          showSuccess('登录成功！');
          joinTeam();
          navFirstPage();
        }
      }
      return { success, message };
    } catch (err) {
      // 请求失败，设置错误信息
      return { success: false, message: '' };
    }
  };

  const wechatLogin = async (code) => {
    try {
      const res = await API.get(`/api/oauth/wechat?code=${code}`);
      const { success, message, data } = res.data;
      if (success) {
        dispatch({ type: LOGIN, payload: data });
        const teamInfo = await getUserTeamInfo();
        setLocalUserInfo({ ...data, ...teamInfo });
        showSuccess('登录成功！');
        joinTeam();
        navFirstPage();
      }
      return { success, message };
    } catch (err) {
      // 请求失败，设置错误信息
      return { success: false, message: '' };
    }
  };

  const logout = async () => {
    await API.get('/api/user/logout');
    let userinfo = {};
    try {
      userinfo = JSON.parse(localStorage.getItem('userinfo'));
    } catch (error) {
      console.log(error);
    }
    localStorage.removeItem('userinfo');
    localStorage.removeItem('console_token');
    localStorage.removeItem('refresh_token');
    if (userinfo?.isSuperLogin) {
      window.location.href = 'https://www.scnet.cn/ui/app/platform';
    } else {
      dispatch({ type: LOGIN, payload: null });
    }
    if (userinfo?.role == 1000) {
      navigate('/login/enterprise/index');
    } else {
      navigate('/login/index');
    }
  };
  const phoneLogin = async (phone, sms_code) => {
    try {
      const res = await API.post(`/api/user/phone/login`, {
        phone,
        sms_code
      });
      const { success, message, data } = res.data;
      if (success) {
        getUserTeamInfo();
        const teamInfo = await getUserTeamInfo();
        setLocalUserInfo({ ...data, ...teamInfo });
        joinTeam();
        dispatch({ type: LOGIN, payload: data });
        navFirstPage();
      }
      return { success, message };
    } catch (err) {
      // 请求失败，设置错误信息
      return { success: false, message: '' };
    }
  };
  const superLogin = async (token) => {
    try {
      const res = await API.get(`/api/user/super/login?token=${token}`);
      const { success, message, data } = res.data;
      if (success) {
        getUserTeamInfo();
        const teamInfo = await getUserTeamInfo();
        setLocalUserInfo({ ...data, ...teamInfo });
        dispatch({ type: LOGIN, payload: data });
        navFirstPage();
      }
      return { success, message };
    } catch (err) {
      // 请求失败，设置错误信息
      return { success: false, message: '' };
    }
  };

  const joinTeam = async () => {
    try {
      const inviteCode = localStorage.getItem('inviteCode');
      if (!inviteCode) return;
      const res = await getJoinTeamBycode(inviteCode);
      const { success, message, loginState } = res.data;
      if (loginState && success) {
        localStorage.removeItem('inviteCode');
      }
    } catch (err) {}
  };

  return { login, logout, githubLogin, wechatLogin, larkLogin, phoneLogin, superLogin, accessTokenLogin };
};

export default useLogin;
